/**
* 子系统
*/
const subsystem = {
  
getSubsystems: "/api/getSubsystems",//查询子系统
setSubsystemContainingFrontEndPages: "/api/setSubsystemContainingFrontEndPages",//设置子系统包含页面
getSubsystemContainingFrontEndPages: "/api/getSubsystemContainingFrontEndPages",//查询子系统包含页面
}

export default subsystem